export default __webpack_public_path__ + "static/media/Hero-Picture 8 - without text.bbef93ba.gif";